/* eslint-disable react/button-has-type */
import {copyToClipboard} from '@/utils';
import {CopyIcon} from '../Icons';
import styles from './index.module.scss';

interface ClipboardCopyProps {
  className?: string;
  text: string;
}

const ClipboardCopy = ({className, text}: ClipboardCopyProps) => (
  <button
    onClick={() => copyToClipboard(text)}
    className={`${className} ${styles.copyIcon} copy-icon`}
  >
    <CopyIcon/>
  </button>
);

export default ClipboardCopy;
